import * as React from 'react';
import { useSelector } from 'react-redux';

import { ExpertView as ExpertViewMobile } from '../../components/ExpertView/views/mobile';
import { ExpertView as ExpertViewDesktop } from '../../components/ExpertView/views/desktop';
import { getExpertViewData } from './utils/getExpertViewData';
import { useIsDesktop } from '../../components/Responsive/utils';
import { trackAdviceLinkClick } from './tracking';

export function ExpertViewContainer() {
  const expertView = useSelector(getExpertViewData);
  const isDesktop = useIsDesktop();

  const onClick = React.useCallback(() => trackAdviceLinkClick(), []);

  if (!expertView) {
    return null;
  }

  return isDesktop ? (
    <ExpertViewDesktop {...expertView} onClick={onClick} />
  ) : (
    <ExpertViewMobile {...expertView} onClick={onClick} />
  );
}
